import { canv } from '@/canv/global.js'

export class shapeArrowLeft {

    constructor() {

    }


    fitText(textPart, x, y, width, height, verticalPadding, horizontalPadding) {

        var allowedWidth = width*2/3 - 2 * horizontalPadding;
        var allowedHeight = height/2- 2 * verticalPadding;


        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        textPart.updateDims();

        textPart.startX = x + width / 3 + 2/3 * width / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            "allowedWidth": allowedWidth,
            "allowedHeight": allowedHeight
        };
    }

    draw(x, y, width, height) {
        canv.ctx.beginPath();
        canv.ctx.moveTo(x, y + height / 2);
        canv.ctx.lineTo(x + width / 3, y);
        canv.ctx.lineTo(x + width / 3, y + height / 4);
        canv.ctx.lineTo(x + width, y + height / 4);
        canv.ctx.lineTo(x + width, y + height * 3/4);
        canv.ctx.lineTo(x + width/3, y + height * 3/4);
        canv.ctx.lineTo(x + width/3, y + height);
        canv.ctx.lineTo(x, y + height / 2);
        canv.ctx.closePath();
    }

    getAvatar(color) {
        return `
        <svg width="70" height="78" viewBox="0 0 70 78" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M39.375 1.44136V16.3333C39.375 16.8856 39.8227 17.3333 40.375 17.3333H69C69.5523 17.3333 70 17.781 70 18.3333V59.6667C70 60.2189 69.5523 60.6667 69 60.6667H40.375C39.8227 60.6667 39.375 61.1144 39.375 61.6667V76.5586C39.375 77.4533 38.29 77.8978 37.6623 77.2602L0.690556 39.7015C0.307426 39.3123 0.307427 38.6877 0.690557 38.2985L37.6623 0.739837C38.29 0.102223 39.375 0.546651 39.375 1.44136Z"
        fill="` + color + `"/>
        </svg>
        `;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 25;
            height = 25;
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="` + width + `" height="` + height + `" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.5 2.22684V4.5C13.5 5.05228 13.9477 5.5 14.5 5.5H23C23.5523 5.5 24 5.94772 24 6.5V17.5C24 18.0523 23.5523 18.5 23 18.5H14.5C13.9477 18.5 13.5 18.9477 13.5 19.5V21.7732C13.5 22.636 12.4805 23.0938 11.8356 22.5206L0.840836 12.7474C0.393321 12.3496 0.393321 11.6504 0.840836 11.2526L11.8356 1.47943C12.4805 0.906189 13.5 1.364 13.5 2.22684Z" fill="` + fill + `" stroke="` + stroke + `"/>
            </svg>
        `;
    }

}
